import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";

class RFSSignoffModal extends React.Component {
  static propTypes = {
    onCancel: PropTypes.func,
    onOk: PropTypes.func,
    isOpen: PropTypes.bool,
  };

  render() {
    return (
      <Modal
        dialogClassName="confirm-cancel-save-eoc-template-dialog"
        show={this.props.isOpen}
        centered="true"
        size="sm"
      >
        <Modal.Header>
          <Modal.Title>Confirmation</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
          Are you sure you want to allow RFS SignOff <b> without </b> the WO being resolved or closed?
          </p>
        </Modal.Body>
        <Modal.Footer>
          <div className="suspend-group-btn" style={{ float: "left" }}>
            <button
              className="btn btn-primary btn-siteone-default"
              onClick={this.props.onCancel}
            >
              Cancel
            </button>
            <button
              style={{ marginLeft: 10 }}
              className="btn btn-primary btn-siteone"
              onClick={this.props.onOk}
            >
              Confirm
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }
}

export default RFSSignoffModal;



// WEBPACK FOOTER //
// ./src/Projects/Components/Template/rfs-signoff-confirm-modal.js